import * as React from 'react';

import moment from 'moment';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import AppState from '../../../../store/state';
import { UpdateField } from '@webapp/store/release/action-creators';

import { CalendarTiers, getCalendarTiers } from '../../../../sdk/plans';

import Datepicker from '@components/form/datepicker';

interface PreviousReleaseTabProps {
  className?: string;
  datePriceTiers: CalendarTiers;
  previousReleaseDate?: string;
  updatePreviousReleaseDate: (
    date?: string
  ) => UpdateField<'previousReleaseDate'>;
}

const mapStateToProps = (state: AppState) => {
  const calendarTiers = getCalendarTiers(
    state.release.release?.trackCount || 1
  );
  return {
    previousReleaseDate: state.release.release?.previousReleaseDate,
    datePriceTiers: calendarTiers,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updatePreviousReleaseDate: (date?: string) =>
    dispatch(
      new UpdateField<'previousReleaseDate'>('previousReleaseDate', date)
    ),
});

export const PreviousReleaseTab: React.FC<PreviousReleaseTabProps> = ({
  previousReleaseDate,
  updatePreviousReleaseDate,
  className,
}) => {
  const getActiveDate = () => {
    if (previousReleaseDate) {
      return moment(previousReleaseDate);
    }
  };

  const getMaxDate = () => moment().endOf('day');

  const handleDateChange = (value: string) => {
    updatePreviousReleaseDate(value);
  };

  const [activeDate] = React.useState(getActiveDate());

  return (
    <div className={className}>
      <div className="datepicker-wrapper">
        <Datepicker
          title="Previous Release Date"
          value={
            previousReleaseDate
              ? moment(previousReleaseDate).format('MMMM DD, YYYY')
              : undefined
          }
          active={activeDate}
          max={getMaxDate()}
          onChange={handleDateChange}
          priceTiers={[]}
        />
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviousReleaseTab);
